module.exports = __webpack_public_path__ + "img/Tree.d3e4fd3d.jpg";